<template>
  <section class="hero">
    <div class="hero-bg" :style="heroStyle" aria-hidden="true"></div>
    <div class="hero-overlay" aria-hidden="true"></div>
    <div class="container hero-content">
      <div class="lg:w-3/4">
        <h1 class="hero-title">
          {{ blog.Title }}
        </h1>
      </div>
    </div>
  </section>
  <section class="flex flex-col min-h-screen">
    <div class="container content">
      <div class="mb-8">
        <div class="flex flex-wrap items-center justify-between gap-6">
          <div class="flex items-center gap-3 mt-7">
            <!--            <img-->
            <!--              src="/adminresmigelecek.png"-->
            <!--              alt="avatar"-->
            <!--              class="h-11 w-11 rounded-full"-->
            <!--            />-->
            <div>
              <h6 class="text-sm transition-all hover:text-primary">
                <a href="#">{{ blog.AdminName }}</a>
              </h6>
              <p class="text-sm text-gray-500" v-if="blog.UpdatedAt">
                {{ timeFormatter(blog.UpdatedAt) }}
              </p>
            </div>
          </div>
          <div class="flex gap-2">
            <p class="text-sm text-gray-500">Paylaş :</p>
            <div class="flex gap-3">
              <span
                ><a
                  :href="
                    'https://www.facebook.com/sharer/sharer.php?u=' + currentUrl
                  "
                  target="_blank"
                  ><svg
                    class="w-5 h-5 text-blue-500"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path
                      d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"
                    ></path></svg></a></span
              ><span
                ><a
                  :href="'https://twitter.com/intent/tweet?url=' + currentUrl"
                  target="_blank"
                  ><svg
                    class="w-5 h-5 text-teal-500"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path
                      d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"
                    ></path></svg></a></span
              ><span
                ><a href="https://www.instagram.com/direct/new/" target="_blank"
                  ><svg
                    class="w-5 h-5 text-red-500"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <rect
                      x="2"
                      y="2"
                      width="20"
                      height="20"
                      rx="5"
                      ry="5"
                    ></rect>
                    <path
                      d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"
                    ></path>
                    <line
                      x1="17.5"
                      y1="6.5"
                      x2="17.51"
                      y2="6.5"
                    ></line></svg></a
              ></span>
            </div>
          </div>
        </div>
      </div>
      <div v-html="blog.Content"></div>
    </div>
  </section>
</template>

<script setup>
import { ref } from "vue";
import { useRoute } from "vue-router";
import { getBlog, timeFormatter } from "@/services/contentService";
import { useLoadingStore } from "@/stores/loadingStore";

// `setup` fonksiyonu içinde `useRoute`'u çağırıyoruz.
const route = useRoute();
const currentUrl = ref(window.location.href);
const loadingStore = useLoadingStore();

var slug = route.path;

const blog = ref("");
const heroStyle = ref({});

// `slug` parametresini console'a yazdırıyoruz
loadingStore.startLoading();
getBlog(slug).then((data) => {
  loadingStore.finishLoading();
  blog.value = data;
  heroStyle.value = blog.value?.FeaturedImage
    ? { backgroundImage: `url(${blog.value.FeaturedImage})` }
    : {};
});
</script>

<style scoped>
.hero {
  position: relative;
  --nav-height: 80px;
  min-height: 70vh;
  width: 100%;
  overflow: hidden;
  display: flex;
  align-items: flex-end;
  padding: calc(6rem + var(--nav-height)) 0 3rem;
}

.hero-bg {
  position: absolute;
  left: 0;
  right: 0;
  top: var(--nav-height);
  bottom: 0;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  transform: scale(1.05);
}

.hero-overlay {
  position: absolute;
  left: 0;
  right: 0;
  top: var(--nav-height);
  bottom: 0;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0.35) 0%,
    rgba(0, 0, 0, 0.55) 45%,
    rgba(0, 0, 0, 0.75) 100%
  );
}

.hero-content {
  position: relative;
  z-index: 1;
}

.hero-title {
  color: #ffffff;
  font-weight: 700;
  line-height: 1.15;
  font-size: clamp(2rem, 3.5vw, 3.5rem);
  text-shadow: 0 10px 30px rgba(0, 0, 0, 0.45);
}

.content {
  padding-top: 2.5rem;
  padding-bottom: 4rem;
}

.content :deep(*) {
  box-sizing: border-box;
}

.content :deep(h1),
.content :deep(h2),
.content :deep(h3),
.content :deep(h4),
.content :deep(h5),
.content :deep(h6) {
  color: #0f172a;
  font-weight: 700;
  line-height: 1.2;
  margin: 1.75rem 0 0.75rem;
}

.content :deep(h1) {
  font-size: clamp(1.75rem, 2.6vw, 2.5rem);
}

.content :deep(h2) {
  font-size: clamp(1.5rem, 2.2vw, 2rem);
}

.content :deep(h3) {
  font-size: clamp(1.25rem, 1.8vw, 1.5rem);
}

.content :deep(p) {
  color: #1f2937;
  font-size: 1.0625rem;
  line-height: 1.75;
  margin: 0 0 1.25rem;
}

.content :deep(a) {
  color: #2563eb;
  text-decoration: underline;
  text-underline-offset: 3px;
}

.content :deep(ul),
.content :deep(ol) {
  color: #1f2937;
  margin: 0 0 1.25rem 1.5rem;
  line-height: 1.7;
}

.content :deep(li) {
  margin: 0.35rem 0;
}

.content :deep(blockquote) {
  margin: 1.5rem 0;
  padding: 1rem 1.25rem;
  border-left: 4px solid rgba(37, 99, 235, 0.35);
  background: rgba(37, 99, 235, 0.06);
  color: #0f172a;
  font-style: italic;
}

.content :deep(img) {
  max-width: 100%;
  height: auto;
  border-radius: 0.75rem;
  margin: 1.5rem 0;
}

.content :deep(hr) {
  border: 0;
  border-top: 1px solid rgba(15, 23, 42, 0.1);
  margin: 2rem 0;
}

.content :deep(table) {
  width: 100%;
  border-collapse: collapse;
  margin: 1.5rem 0;
  font-size: 0.95rem;
}

.content :deep(th),
.content :deep(td) {
  border: 1px solid rgba(15, 23, 42, 0.12);
  padding: 0.75rem;
  text-align: left;
}

.content :deep(th) {
  background: rgba(15, 23, 42, 0.04);
}

@media (max-width: 768px) {
  .hero {
    min-height: 55vh;
    padding: calc(5rem + var(--nav-height)) 0 2.5rem;
  }

  .hero-bg {
    background-attachment: scroll;
  }
}

:global(#navbar) {
  background-color: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}
</style>
